import { useContext, createContext } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const ToastContext = /*#__PURE__*/createContext(false);

/**
 * react-toastify dependency provider
 */
function ToastProvider(props) {
  const {
    children,
    toastPortal: ToastPortal
  } = props;
  const hasToastPortal = !!ToastPortal;
  return /*#__PURE__*/jsxs(ToastContext.Provider, {
    value: hasToastPortal,
    children: [ToastPortal && /*#__PURE__*/jsx(ToastPortal, {}), children]
  });
}
function useHasToastPortal() {
  const hasToastPortal = useContext(ToastContext);
  return hasToastPortal;
}

export { ToastProvider, useHasToastPortal };
